$shm_dashboard_admin_auth $mol_page
	title \Вход superuser
	dashboard_url? \https://dashboard.shmakov.media/
	email? \
	password? \
	token? \
	user_id? \
	message? \
	body <= content_rows /
	Login_form $mol_view
		sub /
			<= Dashboard_label $mol_labeler
				title \Dashboard
				content /
					<= Dashboard $mol_select
						value? <=> dashboard_url? \https://dashboard.shmakov.media/
						dictionary <= dashboard_options *
			<= Email_label $mol_labeler
				title \Email
				content /
					<= Email $mol_string
						hint \pb@example.com
						value? <=> email? \
			<= Password_label $mol_labeler
				title \Пароль
				content /
					<= Password $mol_password
						value? <=> password? \
						submit? <=> submit? null
			<= Submit $mol_button_major
				title \Войти
				click? <=> submit? null
				enabled <= submit_enabled true
			<= Message $mol_text
				text <= message? \
	Session $mol_view
		sub /
			<= Current_label $mol_labeler
				title \Superuser
				content /
					<= Current_user $mol_view
						sub / <= superuser_label \
			<= Logout $mol_button_minor
				title \Выйти
				click? <=> logout? null
